import { render, staticRenderFns } from "./MonitorAdminLabel.vue?vue&type=template&id=8d13bb5a&scoped=true"
import script from "./MonitorAdminLabel.vue?vue&type=script&lang=js"
export * from "./MonitorAdminLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d13bb5a",
  null
  
)

export default component.exports